module.exports = __webpack_public_path__ + "img/check-white.d3670b22.svg";